import { motion } from "framer-motion";

export const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] },
  }),
};

export default function Reveal({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      className={className}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-80px" }}
      custom={delay}
      variants={fadeUp}
    >
      {children}
    </motion.div>
  );
}

export function Eyebrow({ children, dark = false }) {
  return (
    <span
      className={`inline-block text-xs font-semibold uppercase tracking-[0.25em] ${
        dark ? "text-[#C9A15A]" : "text-[#C9A15A]"
      }`}
    >
      {children}
    </span>
  );
}
